export default function SuccessGreenIcon() {
  return (
    <>
      <svg
        width="77"
        height="76"
        viewBox="0 0 77 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="76" height="76" rx="38" fill="#D7FFEB" />
        <path
          d="M32.5 38L36.302 41.4218C36.9493 42.0043 37.9549 41.9151 38.4895 41.2278L44.5 33.5M38.5 53C46.7843 53 53.5 46.2843 53.5 38C53.5 29.7157 46.7843 23 38.5 23C30.2157 23 23.5 29.7157 23.5 38C23.5 46.2843 30.2157 53 38.5 53Z"
          stroke="#11A75C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
